import { render } from "./DateTimeDisplay.vue?vue&type=template&id=5a34ee2c&scoped=true"
import script from "./DateTimeDisplay.vue?vue&type=script&lang=ts"
export * from "./DateTimeDisplay.vue?vue&type=script&lang=ts"

import "./DateTimeDisplay.vue?vue&type=style&index=0&id=5a34ee2c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5a34ee2c"

export default script